/**
 * A curated list of Thai universities (public + well-known private),
 * kept locally so the Register form's autocomplete works with Thai-language
 * input without depending on an external API (most public university
 * datasets only store English names).
 *
 * Feel free to extend this list — each entry just needs `th` and `en`.
 */
const THAI_UNIVERSITIES = [
  { th: "จุฬาลงกรณ์มหาวิทยาลัย", en: "Chulalongkorn University" },
  { th: "มหาวิทยาลัยธรรมศาสตร์", en: "Thammasat University" },
  { th: "มหาวิทยาลัยมหิดล", en: "Mahidol University" },
  { th: "มหาวิทยาลัยเกษตรศาสตร์", en: "Kasetsart University" },
  { th: "มหาวิทยาลัยเชียงใหม่", en: "Chiang Mai University" },
  { th: "มหาวิทยาลัยขอนแก่น", en: "Khon Kaen University" },
  { th: "มหาวิทยาลัยสงขลานครินทร์", en: "Prince of Songkla University" },
  { th: "มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี", en: "King Mongkut's University of Technology Thonburi" },
  { th: "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง", en: "King Mongkut's Institute of Technology Ladkrabang" },
  { th: "มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ", en: "King Mongkut's University of Technology North Bangkok" },
  { th: "มหาวิทยาลัยศรีนครินทรวิโรฒ", en: "Srinakharinwirot University" },
  { th: "มหาวิทยาลัยศิลปากร", en: "Silpakorn University" },
  { th: "มหาวิทยาลัยรามคำแหง", en: "Ramkhamhaeng University" },
  { th: "มหาวิทยาลัยสุโขทัยธรรมาธิราช", en: "Sukhothai Thammathirat Open University" },
  { th: "สถาบันบัณฑิตพัฒนบริหารศาสตร์", en: "National Institute of Development Administration (NIDA)" },
  { th: "มหาวิทยาลัยเทคโนโลยีสุรนารี", en: "Suranaree University of Technology" },
  { th: "มหาวิทยาลัยวลัยลักษณ์", en: "Walailak University" },
  { th: "มหาวิทยาลัยแม่ฟ้าหลวง", en: "Mae Fah Luang University" },
  { th: "มหาวิทยาลัยบูรพา", en: "Burapha University" },
  { th: "มหาวิทยาลัยนเรศวร", en: "Naresuan University" },
  { th: "มหาวิทยาลัยมหาสารคาม", en: "Mahasarakham University" },
  { th: "มหาวิทยาลัยอุบลราชธานี", en: "Ubon Ratchathani University" },
  { th: "มหาวิทยาลัยทักษิณ", en: "Thaksin University" },
  { th: "มหาวิทยาลัยแม่โจ้", en: "Maejo University" },
  { th: "มหาวิทยาลัยพะเยา", en: "University of Phayao" },
  { th: "มหาวิทยาลัยศรีปทุม", en: "Sripatum University" },
  { th: "มหาวิทยาลัยกรุงเทพ", en: "Bangkok University" },
  { th: "มหาวิทยาลัยหอการค้าไทย", en: "University of the Thai Chamber of Commerce (UTCC)" },
  { th: "มหาวิทยาลัยธุรกิจบัณฑิตย์", en: "Dhurakij Pundit University" },
  { th: "มหาวิทยาลัยรังสิต", en: "Rangsit University" },
  { th: "มหาวิทยาลัยอัสสัมชัญ", en: "Assumption University (ABAC)" },
  { th: "มหาวิทยาลัยกรุงเทพธนบุรี", en: "Bangkokthonburi University" },
  { th: "มหาวิทยาลัยเอเชียอาคเนย์", en: "South-East Asia University" },
  { th: "มหาวิทยาลัยหัวเฉียวเฉลิมพระเกียรติ", en: "Huachiew Chalermprakiet University" },
  { th: "มหาวิทยาลัยสยาม", en: "Siam University" },
  { th: "มหาวิทยาลัยเวสเทิร์น", en: "Western University" },
  { th: "มหาวิทยาลัยนอร์ทกรุงเทพ", en: "North Bangkok University" },
  { th: "มหาวิทยาลัยเทคโนโลยีราชมงคลธัญบุรี", en: "Rajamangala University of Technology Thanyaburi" },
  { th: "มหาวิทยาลัยเทคโนโลยีราชมงคลกรุงเทพ", en: "Rajamangala University of Technology Krungthep" },
  { th: "มหาวิทยาลัยเทคโนโลยีราชมงคลพระนคร", en: "Rajamangala University of Technology Phra Nakhon" },
  { th: "มหาวิทยาลัยเทคโนโลยีราชมงคลอีสาน", en: "Rajamangala University of Technology Isan" },
  { th: "มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา", en: "Rajamangala University of Technology Lanna" },
  { th: "มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย", en: "Rajamangala University of Technology Srivijaya" },
  { th: "มหาวิทยาลัยเทคโนโลยีราชมงคลรัตนโกสินทร์", en: "Rajamangala University of Technology Rattanakosin" },
  { th: "มหาวิทยาลัยราชภัฏสวนสุนันทา", en: "Suan Sunandha Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏจันทรเกษม", en: "Chandrakasem Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏบ้านสมเด็จเจ้าพระยา", en: "Bansomdejchaopraya Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏพระนคร", en: "Phranakhon Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏธนบุรี", en: "Dhonburi Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏเชียงใหม่", en: "Chiang Mai Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏนครราชสีมา", en: "Nakhon Ratchasima Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏอุดรธานี", en: "Udon Thani Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏสงขลา", en: "Songkhla Rajabhat University" },
  { th: "มหาวิทยาลัยราชภัฏภูเก็ต", en: "Phuket Rajabhat University" },
  { th: "สถาบันเทคโนโลยีไทย-ญี่ปุ่น", en: "Thai-Nichi Institute of Technology" },
  { th: "สถาบันการจัดการปัญญาภิวัฒน์", en: "Panyapiwat Institute of Management" },
  { th: "โรงเรียนนายร้อยพระจุลจอมเกล้า", en: "Chulachomklao Royal Military Academy" },
  { th: "มหาวิทยาลัยเทคโนโลยีมหานคร", en: "Mahanakorn University of Technology" },
  { th: "มหาวิทยาลัยนานาชาติแสตมฟอร์ด", en: "Stamford International University" },
  { th: "มหาวิทยาลัยเซนต์จอห์น", en: "Saint John's University" },
  { th: "มหาวิทยาลัยอีสเทิร์นเอเชีย", en: "Eastern Asia University" },
];

export default THAI_UNIVERSITIES;
